



















































        
import { AloPanier } from '@/models/alo/AloPanier'
import { toStringDictionary } from '@/utils/groupBy'
import { timeFromString } from '@/utils/time'  
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'DeliveryPicker', 
  props:{                        
    value:{
      type:String,
      default:""
    },            
    label:{
      type:String,
      default:"Horaire"
    },     
    panier:{
      type:Object,
      default:null
    },
    nbResaMaxPerSlot:{
      type:Number,
      default:3
    },
    slotDuration:{
      type:Number,
      default:15
    },
    disableIfFull:{
      type:Boolean,
      default:true
    },
    readOnly:{
      type:Boolean,
      default:false
    }
  }
})
export default class NumberFieldFactor extends Vue {  

  showPicker = false  
  label!:string    
  panier!:AloPanier    
  selectedDay = 0    
  value!:string
  nbResaMaxPerSlot!:number
  slotDuration!:number
  loading = false
  disableIfFull!:boolean
  readOnly!:Boolean

  @Watch("showPicker")
  onShowPickerChanged(newValue:boolean){
    if(newValue) {
      this.loading = true        
      this.$store.myActions.ROOM_SERVICES_CRENAUX_REQUEST().then(()=>{
        //on cherche si la date semectionnée est dans les demains
        if(this.groupCrenaux[1].crenaux.findIndex(it => it.date.toString() == this.value ) > -1 ) this.selectedDay = 1
        //sinon on affiche les propositions pour aujourd'hui si il y en a
        else this.selectedDay = this.groupCrenaux[0].crenaux.length>0?0:1
      }).finally(()=>{
        this.loading = false
      })
      
    }
  }

  minDateCrenaux(){
    return new Date(this.today().getTime() + this.minTodayTime())
  }

  get crenaux(){
    return this.$store.myGetters.crenaux.map(c => {return {nbResa:c.nbResa,date:new Date(c.date)}})
  }

  get tomorrow() {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    tomorrow.setHours(0,0,0,0)
    return tomorrow
  }

  today() {
    const today = new Date()            
    today.setHours(0,0,0,0)
    return today
  }
  
  formatIsoDate(date:string){
    //@ts-ignore
    return `${this.$options.filters.formatDate(date,"YYYY-MM-DDTHH:mm")}:00.000Z`
  }
  
  get dicCrenauxToday() {
    return toStringDictionary(this.crenaux.filter(d => d.date< this.tomorrow),d => this.$options.filters!.formatDate(d.date,"HH:mm"))
  }        

  get dicCrenauxTomorrow() {
    return toStringDictionary(this.crenaux.filter(d => d.date >= this.tomorrow),d => this.$options.filters!.formatDate(d.date,"HH:mm"))
  }    

  
  firstAllowedTime() {
    return timeFromString(this.$options.filters!.formatDate(new Date(),"HH:mm")) + (this.panier?(this.panier.tempsPreparation * 60000):0)
  }

  minTodayTime()  {
    return Math.max(this.firstAllowedTime(),this.minTomorrowTime)    
  }

  get minTomorrowTime(){
    return this.panier?.timeDebut || 0
  }

  get maxTime() {
    return this.panier?.timeFin || timeFromString("23:59")
  }    

  get groupCrenaux() {
    const group = [        
      {          
        label:this.$t("Global.Today"),
        crenaux:this.todaysCrenaux
      },
      {
        label:this.$t("Global.Tomorrow"),
        crenaux:this.tomorowCrenaux
      }
    ]      
    return group
  }
    
  get todaysCrenaux()   {
    const crenaux = [] as Array<{date:Date,nbResa:number}>
    let start = this.minTomorrowTime      
    while(start <= this.maxTime) {  
      if(start >=  this.minTodayTime())
      {
        const date = new Date(this.today().getTime() + start)
        crenaux.push( {
          date,            
          nbResa:this.dicCrenauxToday[this.$options.filters!.formatDate(date,"HH:mm")]?.nbResa || 0
        })         
      }         
      //ajout de 15 min
      start += (this.slotDuration * 60000)
    }
    return crenaux
  }

  get tomorowCrenaux()   {
    const crenaux = [] as Array<{date:Date,nbResa:number}>
    let start = this.minTomorrowTime      
    while(start <= this.maxTime) {                  
      const date = new Date(this.tomorrow.getTime() + start)
      crenaux.push( {
        date,            
        nbResa:this.dicCrenauxTomorrow[this.$options.filters!.formatDate(date,"HH:mm")]?.nbResa || 0
      })                          
      //ajout de 15 min
      start += (this.slotDuration * 60000)
    }
    return crenaux
  }

  get selectedCrenaux() {      
    return this.value.length > 0?`${this.$options.filters!.formatDate(this.value,"dddd DD MMMM",this.$i18n,true)} ${this.$t("Global.Between")} ${this.$options.filters!.formatDate(this.value,"HH:mm",this.$i18n,true)} ${this.$t("Global.And")} ${this.$options.filters!.formatDate(new Date(new Date(this.value).getTime() + (this.slotDuration * 60000)),"HH:mm",this.$i18n,true)}`:''
  }

}
